export function buildCSV(header: string, rows: Array<string>) {
  return 'data:text/csv;charset=utf-8,' + [header, ...rows].join('\n');
}
